import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  description?: string;
  action?: ReactNode;
}

export function PageHeader({ title, description, action }: PageHeaderProps) {
  // Responsive (RFC-0014): below `md` the action stacks BELOW the title, full
  // width, so a wide/multi-control action (e.g. the /graph control row) wraps
  // instead of overflowing the viewport horizontally. At `md`+ it returns to the
  // original title-left / action-right row (`md:shrink-0` keeps the action at its
  // intrinsic width, unsquished). `min-w-0` lets both flex children shrink so
  // their own wrapping/truncation actually takes effect rather than forcing
  // horizontal page scroll.
  return (
    <div className="mb-6 flex flex-col gap-4 md:flex-row md:items-start md:justify-between">
      <div className="min-w-0">
        <h1 className="text-[22px] font-bold tracking-tight text-text">
          {title}
        </h1>
        {description && <p className="text-sm text-muted mt-1">{description}</p>}
      </div>
      {action && <div className="min-w-0 md:shrink-0">{action}</div>}
    </div>
  );
}
